
import { getFirstDayOfYear, initialDate } from '@/service/ApplicationQueries';
import { useCallback, useState } from 'react';

interface DateFilters {
    StartDate: Date | null;
    EndDate: Date | null;
    SelectedUser: number
}

const initialDataFilters: DateFilters = {
    StartDate: getFirstDayOfYear(),
    EndDate: initialDate(),
    SelectedUser: 0
}

const useDataFilters = () => {
    const [selectedUser, setSelectedUser] = useState<number>(0);
    const [dataFilters, setDataFilters] = useState<DateFilters>(initialDataFilters);

    const updateDataFilters = useCallback((startDate: Date | null, endDate: Date | null, selectedUser: number) => {
        setDataFilters({
            StartDate: startDate,
            EndDate: endDate,
            SelectedUser: selectedUser,
        });
    }, [setDataFilters]);

    const resetDataFilters = () => {
        setDataFilters({
            StartDate: getFirstDayOfYear(),
            EndDate: initialDate(),
            SelectedUser: 0,
        });
    }

    return {
        dataFilters,
        selectedUser,
        updateDataFilters,
        resetDataFilters
    };
};

export default useDataFilters;